// extracted by mini-css-extract-plugin
export default {"header":"zS","container":"AS","accordeonitem":"BS","itemsticky":"CS","itemopen":"ES","open":"FS","productname":"GS","productinfo":"HS","flavorstext":"IS","invalidlimit":"JS","limit":"KS","scrollUpAccordion":"LS","wrapper":"MS"};
    if(module.hot) {
      // 1738064242779
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  